export default "__VITE_ASSET__be2ae793__"